(() => {
  const selector = "[data-count-up-number]";
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  if (reduceMotion.matches) return;

  const parseMetric = (value) => {
    const raw = (value || "").trim();
    const match = raw.match(/-?\d[\d,]*(?:\.\d+)?/);

    if (!match) return null;

    const numberText = match[0];
    const target = Number.parseFloat(numberText.replace(/,/g, ""));

    if (!Number.isFinite(target)) return null;

    const decimalPart = numberText.split(".")[1];

    return {
      target,
      prefix: raw.slice(0, match.index),
      suffix: raw.slice(match.index + numberText.length),
      decimals: decimalPart ? decimalPart.length : 0,
      useGrouping: numberText.includes(","),
    };
  };

  const formatMetric = (value, metric) => {
    const rounded = value.toFixed(metric.decimals);
    const formatted = metric.useGrouping
      ? Number(rounded).toLocaleString(undefined, {
          minimumFractionDigits: metric.decimals,
          maximumFractionDigits: metric.decimals,
        })
      : rounded;

    return `${metric.prefix}${formatted}${metric.suffix}`;
  };

  const animateMetric = (element) => {
    if (element.dataset.countUpPlayed === "true") return;

    const metric = parseMetric(element.dataset.countUpOriginal || element.textContent);
    if (!metric) return;

    element.dataset.countUpPlayed = "true";

    const section = element.closest(".wt-metric-banner-section");
    const countItems = section ? Array.from(section.querySelectorAll(selector)) : [];
    const delay = Math.max(0, countItems.indexOf(element)) * 0.08;

    if (window.sonicLoadGSAP) {
      window
        .sonicLoadGSAP()
        .then(({ gsap }) => {
          if (!gsap) {
            animateMetricFallback(element, metric);
            return;
          }

          const state = { value: 0 };
          const timeline = gsap.timeline({ delay });

          element.textContent = formatMetric(0, metric);

          timeline.fromTo(
            element,
            { y: 10, opacity: 0.68, filter: "blur(3px)" },
            {
              y: 0,
              opacity: 1,
              filter: "blur(0px)",
              duration: 0.55,
              ease: "power3.out",
              clearProps: "transform,opacity,filter",
            },
            0
          );

          timeline.to(
            state,
            {
              value: metric.target,
              duration: 1.35,
              ease: "power4.out",
              onUpdate: () => {
                element.textContent = formatMetric(state.value, metric);
              },
              onComplete: () => {
                element.textContent = element.dataset.countUpOriginal;
              },
            },
            0
          );
        })
        .catch(() => animateMetricFallback(element, metric));

      return;
    }

    animateMetricFallback(element, metric, delay);
  };

  const animateMetricFallback = (element, metric, delay = 0) => {
    const duration = 1200;
    const start = performance.now() + delay * 1000;

    const tick = (now) => {
      if (now < start) {
        requestAnimationFrame(tick);
        return;
      }

      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      element.textContent = formatMetric(metric.target * eased, metric);

      if (progress < 1) {
        requestAnimationFrame(tick);
      } else {
        element.textContent = element.dataset.countUpOriginal;
      }
    };

    requestAnimationFrame(tick);
  };

  const init = (root = document) => {
    const elements = Array.from(root.querySelectorAll(selector));
    if (!elements.length) return;

    if (!("IntersectionObserver" in window)) {
      elements.forEach(animateMetric);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          animateMetric(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.35 }
    );

    elements.forEach((element) => observer.observe(element));
  };

  init();

  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
